import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

export default function DealDescriptionDialog({ value, onChange, onClose, onSave, saving, dirty, saved, error }) {
  const dialog = useRef(null)
  useEffect(() => { dialog.current?.showModal() }, [])
  const close = () => { if (!saving) onClose() }
  return createPortal(<dialog ref={dialog} className="dp-discount-dialog dp-description-dialog" aria-labelledby="dp-description-title"
    onCancel={event => { event.preventDefault(); close() }}
    onKeyDown={event => { if (event.key === 'Escape') event.stopPropagation() }}
    onClick={event => { if (event.target === event.currentTarget) close() }}>
    <header><h2 id="dp-description-title">Descrição do negócio</h2><button type="button" onClick={close} disabled={saving} aria-label="Fechar descrição">×</button></header>
    <textarea aria-label="Descrição do negócio" value={value} disabled={saving} onChange={event => onChange(event.target.value)} placeholder="Adicione detalhes sobre o negócio…" />
    {error && <p role="alert">{error}</p>}
    <footer><span>{saved && !dirty ? 'Descrição salva' : dirty ? 'Alterações ainda não salvas' : ''}</span><button type="button" disabled={saving} onClick={close}>Voltar ao painel</button><button type="button" disabled={saving || !dirty} onClick={onSave}>{saving ? 'Salvando…' : 'Salvar descrição'}</button></footer>
  </dialog>, document.body)
}
